// extracted by mini-css-extract-plugin
export default {"root":"yeNPh0","filter":"q7jwfc","title":"WYun9M","telegramIcon":"IkYNob","button":"uiB7Ub","text":"WxtaOs"};